import ContactForm from '../../components/contactForm/contactForm';
import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider.module.js';
import VideoPlayer from '../../components/videoPlayer/videoPlayer';

const queryString = require('query-string');
const EventEmitter = require('event-emitter-es6');

export default class ManagementSolutionDialog extends EventEmitter {
    constructor() {
        super();
        this.el = document.querySelector('.managementSolutionDialog');

        this.dialogHolderEl = this.el.querySelector(
            '.managementSolutionDialog__inner'
        );
        this.dialogInnerEl = this.el.querySelector(
            '.managementSolutionDialog__content'
        );
        this.dialogPrevEl = this.el.querySelector('.container .prev');
        this.dialogNextEl = this.el.querySelector('.container .next');
        this.dialogTopBarPrevEl = this.el.querySelector(
            '.managementSolutionDialog__topBarButton.prev'
        );
        this.dialogTopBarNextEl = this.el.querySelector(
            '.managementSolutionDialog__topBarButton.next'
        );
        this.dialogTopBarCloseEl = this.el.querySelector(
            '.managementSolutionDialog__topBarButton.close'
        );
        this.dialogCloseEl = this.el.querySelector(
            '.managementSolutionDialog__closeButton'
        );

        this.state = {
            items: null,
            openIndex: null
        };

        this.bindEvents();
    }

    bindEvents() {
        this.form = new ContactForm(
            this.el.querySelector('.managementSolutionDialog__form')
        );

        this.dialogPrevEl.addEventListener('click', () => this.prevItem());
        this.dialogNextEl.addEventListener('click', () => this.nextItem());
        this.dialogTopBarPrevEl.addEventListener('click', () =>
            this.prevItem()
        );
        this.dialogTopBarNextEl.addEventListener('click', () =>
            this.nextItem()
        );
        this.dialogCloseEl.addEventListener('click', () => this.closeDialog());
        this.dialogTopBarCloseEl.addEventListener('click', () =>
            this.closeDialog()
        );

        document.addEventListener('keydown', event =>
            event.keyCode === 27 ? this.closeDialog() : null
        );
    }

    setItems(items) {
        this.state.items = items;
    }

    checkForOpenItem() {
        const parsed = queryString.parse(window.location.search);

        if (parsed.open && this.state.items[parsed.open]) {
            this.open(parsed.open);
        }
    }

    prevItem() {
        let index = this.state.openIndex;

        if (index > 0) {
            index--;
        } else {
            index = this.state.items.length - 1;
        }

        this.open(index);
    }

    nextItem() {
        let index = this.state.openIndex;

        if (index < this.state.items.length - 1) {
            index++;
        } else {
            index = 0;
        }

        this.open(index);
    }

    open(index) {
        document.body.style.overflow = 'hidden';
        const item = this.state.items[index];

        this.state.openIndex = index;

        let tags = '';

        for (let i = 0; i < item.categories.length; i++) {
            tags += `
                <span class="managementSolutionDialog__tag">
                    ${item.categories[i].name}
                </span>
            `;
        }

        let gallery = '';

        for (let i = 0; i < item.images.length; i++) {
            let videoClass = item.images[i].video_link ? ' js-playVideo' : '';
            gallery += `
                <div
                    class="${videoClass}"
                    data-video="${item.images[i].video_link}">
                    <img
                        src="${item.images[i].image.sizes.medium_large}"
                        alt="${item.images[i].image.alt}"
                        class="managementSolutionDialog__galleryImage objectFitCover"
                    >
                </div>
            `;
        }

        let products = '';

        if (item.products != null && item.products.length > 0) {
            products = `
                <div class="managementSolutionDialog__products">
                    <h4>${window.translations.products}:</h4>
            `;
            for (let i = 0; i < item.products.length; i++) {
                const product = item.products[i];

                products += `
                    <a
                        href="${product.permalink}"
                        class="managementSolutionDialog__product"
                    >
                        <img
                            src="${product.image.sizes.medium_large}"
                            alt="${product.image.alt}"
                            class="managementSolutionDialog__productImage"
                        >
                        <p class="managementSolutionDialog__productTitle">${
                            product.title
                        }</p>
                    </a>
                `;
            }
            products += '</div>';
        }

        this.dialogInnerEl.innerHTML = `
            <div class="managementSolutionDialog__top">
                <div class="managementSolutionDialog__left">
                    <div class="managementSolutionDialog__gallery">
                        ${gallery}
                    </div>
                </div>
                <div class="managementSolutionDialog__right">
                    <div class="managementSolutionDialog__tags">${tags}</div>
                    <h2 class="managementSolutionDialog__title">
                        ${item.title}
                    </h2>
                    <p class="managementSolutionDialog__id">
                        #${item.id}
                    </p>
                    <p class="managementSolutionDialog__text">
                        ${item.text}
                    </p>
                    ${products}
                </div>
            </div>
        `;

        if (item.images && item.images.length > 1) {
            const slider = tns({
                container: '.managementSolutionDialog__gallery',
                items: 1,
                controls: true,
                autoplay: false,
                autoplayButtonOutput: false,
                controlsText: ['', '']
            });

            this.dialogInnerEl
                .querySelector('.tns-controls')
                .insertAdjacentHTML(
                    'afterbegin',
                    `
                    <div class="tns-counter">
                        <span class="tns-counter-current">1</span>
                        <span>${window.translations.of}</span>
                        <span class="tns-counter-total">${
                            item.images.length
                        }</span>
                    </div>
                `
                );

            const tnsCounter = this.dialogInnerEl.querySelector(
                '.tns-counter-current'
            );

            slider.events.on('transitionEnd', info => {
                tnsCounter.innerText = info.navCurrentIndex + 1;
            });
        }

        this.videoPlayer = new VideoPlayer();

        this.el.classList.add('isActive');
        this.dialogHolderEl.scrollTop = 0;

        this.emit('updateUrl', this.state.openIndex);

        this.form.setExtraData({
            'management_solution': {
                'title': item.title,
                'id': item.id
            }
        });
    }

    closeDialog() {
        document.body.style.overflow = '';
        this.state.openIndex = null;
        this.dialogInnerEl.innerHTM = '';
        this.emit('updateUrl', this.state.openIndex);
        this.el.classList.remove('isActive');
    }
}



// WEBPACK FOOTER //
// ./src/components/managementSolutionDialog/managementSolutionDialog.js